import { Component, Input } from '@angular/core';
import { FormControl, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from 'app/shared/ui/date-picker/date-picker.component';

@Component({
    selector: 'form-date-range',
    imports: [
        DatePickerComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
    template: `
        <div class="form-group">
            <ng-content select="label"></ng-content>
            <div class="form-range">
                <ui-date-picker [attr.id]="formControlFrom" [formControl]="controlFrom"></ui-date-picker>
                <span class="dash">&ndash;</span>
                <ui-date-picker [attr.id]="formControlTo" [formControl]="controlTo"></ui-date-picker>
            </div>
        </div>
    `,
})
export class FormDateRangeComponent {

    @Input() formControlFrom: string;

    @Input() formControlTo: string;

    get controlFrom() {
        return this.formGroup.control.get(this.formControlFrom) as FormControl;
    }

    get controlTo() {
        return this.formGroup.control.get(this.formControlTo) as FormControl;
    }

    constructor(public formGroup: FormGroupDirective) {}
}
